import { useCookie } from 'react-use';
import { KnownCookie, KnownCookies } from '@sls-react/typings/cookies';
import Cookies from 'js-cookie';
import { useServerSideCookies } from '@sls-react/contexts/ServerSideCookies';

type UseKnownCookieReturn<T extends KnownCookie> = [
  value: KnownCookies[T] | null,
  setCookie: (
    newValue: KnownCookies[T],
    options?: Cookies.CookieAttributes | undefined,
  ) => void,
  destroyCookie: () => void,
];

export default function useKnownCookie<T extends KnownCookie>(
  cookieName: T,
): UseKnownCookieReturn<T> {
  const initialCookies = useServerSideCookies();
  const cookieHook = useCookie(cookieName) as UseKnownCookieReturn<T>;

  // During SSR, return simply the cookie.
  if (typeof window == 'undefined') {
    // No-ops
    return [initialCookies[cookieName], cookieHook[1], cookieHook[2]];
  }

  // On the client-side, let the useCookie hook do its thing.
  return cookieHook;
}
